// extracted by mini-css-extract-plugin
export var foam = "dxiOverview-module--foam--2tE92";
export var solitude = "dxiOverview-module--solitude--2pY9W";
export var ice = "dxiOverview-module--ice--399wM";
export var alabaster = "dxiOverview-module--alabaster--2fDzi";
export var gallery = "dxiOverview-module--gallery--1y0_y";
export var headingContainer = "dxiOverview-module--heading-container--2VtGC";
export var textSection = "dxiOverview-module--text-section--2T2hp";
export var margin = "dxiOverview-module--margin--22Tgo";
export var intro = "dxiOverview-module--intro--2FYCK";
export var formGrid = "dxiOverview-module--form-grid--2Yzcb";
export var form = "dxiOverview-module--form--2P3B_";
export var contentCard = "dxiOverview-module--content-card--2UsdH";
export var twoColumns = "dxiOverview-module--two-columns--1RlnW";
export var copy = "dxiOverview-module--copy--1kp7y";
export var fiftySplit = "dxiOverview-module--fifty-split--12M_g";
export var flipped = "dxiOverview-module--flipped--1HDes";
export var boost = "dxiOverview-module--boost--1Y1Zj";
export var boostExtend = "dxiOverview-module--boost-extend--2Th74";
export var formCopy = "dxiOverview-module--form-copy--3gA_W";